import { EnvConfig } from '@core';

export const getNewVersionWebAndroid = (env: EnvConfig): void => {
  window.open(env.androidApkUrl, '_blank');
};

export const getNewVersionWebiOS = (env: EnvConfig): void => {
  window.open(env.iOSApkUrl, '_blank');
};
